import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class FichasObservacoesFixasService extends Service {

  protected url: string = this.dominio + "/adm/fichas/observacoes-fixas/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/fichas-observacoes-fixas/observacoes-fixas.service.ts